import request from '@/utils/request'
/**
 * 获取 个人/团队 账单列表
 * */
export function getOrderList(data) {
  return request({
    url: '/api/order/get-order-list',
    method: 'post',
    data
  })
}

/**
 * 查询订单信息
 * */
export function getOrderInfo(data) {
  return request({
    url: '/api/order/get-order-info',
    method: 'post',
    data
  })
}

/**
 * 查询订单信息
 * */
export function downInvoicePdf(data) {
  return request({
    url: '/api/order/down-invoice-pdf',
    method: 'post',
    data
  })
}

export function applyInvoice(data) {
  return request({ url: '/api/order/invoice/apply', method: 'post', data })
}

export function getInvoiceDetail(params) {
  return request({ url: '/api/order/invoice/detail', method: 'get', params })
}

export function downloadInvoice(params) {
  return request({ url: '/api/order/invoice/download', method: 'get', params })
}
